import { ProductCardLayout } from "../types/types";
import * as layouts from "./";

export const layoutMap: { [name: string]: ProductCardLayout } = layouts;
